<div class="sections">
    <div>
        <form [formGroup]="form">
            <div class="field">
                <h4>Business website (Optional)</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="website"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('website', true)"
                           (focusout)="activeExplanationChange('website', false)"
                           enterkeyhint="next"
                    />
                </mat-form-field>
            </div>
            <div class="field">
                <h4>Business type</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <input matInput
                           formControlName="businessType"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="activeExplanationChange('businessType', true)"
                           (focusout)="activeExplanationChange('businessType', false)"
                           enterkeyhint="next"
                    />
                    <mat-error *ngIf="formControlError(form, 'businessType') === 'required'">Business type is required</mat-error>
                </mat-form-field>
            </div>
            <div class="field">
                <h4>Business Description</h4>
                <mat-form-field appearance="outline" appFormFieldFilled class="textarea">
                    <textarea matInput
                           formControlName="description"
                           autocomplete="off"
                           name="avoidSearch"
                           cdkTextareaAutosize
                           cdkAutosizeMinRows="2"
                           cdkAutosizeMaxRows="5"
                           (focus)="activeExplanationChange('description', true)"
                           (focusout)="activeExplanationChange('description', false)"
                           enterkeyhint="next"
                    ></textarea>
                    <mat-error *ngIf="formControlError(form, 'description') === 'required'">Business description is required</mat-error>
                </mat-form-field>
            </div>
            <div class="field multiple">
                <div class="field flex-fill">
                    <h4>Zoning</h4>
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="trigger-area" (click)="zoningAutocomplete.isOpen ? zoningTrigger.closePanel() : zoningTrigger.openPanel()"></div>
                            <input matInput #zoningInput
                               [matAutocomplete]="zoningAutocomplete"
                               #zoningTrigger="matAutocompleteTrigger"
                               [anchorAutocompleteOnScroll]="zoningTrigger"
                               formControlName="zoning"
                               autocomplete="off"
                               name="avoidSearch"
                               (focus)="zoningInput.blur()"
                               enterkeyhint="next"
                            />
                            <mat-icon matSuffix class="rotate" [class.do]="zoningAutocomplete.isOpen">expand_more</mat-icon>
                        </div>
                        <mat-autocomplete #zoningAutocomplete="matAutocomplete"
                                          (opened)="activeExplanationChange('zoning', true)"
                                          (closed)="activeExplanationChange('zoning', false)"
                        >
                            <mat-option value="Commercial">
                                Commercial
                            </mat-option>
                            <mat-option value="Residential">
                                Residential
                            </mat-option>
                            <mat-option value="Industrial">
                                Industrial
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="formControlError(form, 'zoning') === 'required'">Zoning is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="field flex-fill">
                    <h4>Local</h4>
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="trigger-area" (click)="localeAutocomplete.isOpen ? localeTrigger.closePanel() : localeTrigger.openPanel()"></div>
                            <input matInput #localeInput
                               [matAutocomplete]="localeAutocomplete"
                               #localeTrigger="matAutocompleteTrigger"
                               [anchorAutocompleteOnScroll]="localeTrigger"
                               formControlName="locale"
                               autocomplete="off"
                               name="avoidSearch"
                               (focus)="localeInput.blur()"
                               enterkeyhint="next"
                            />
                            <mat-icon matSuffix class="rotate" [class.do]="localeAutocomplete.isOpen">expand_more</mat-icon>
                        </div>
                        <mat-autocomplete #localeAutocomplete="matAutocomplete"
                                          (opened)="activeExplanationChange('locale', true)"
                                          (closed)="activeExplanationChange('locale', false)"
                        >
                            <mat-option value="Mail">
                                Mail
                            </mat-option>
                            <mat-option value="Office">
                                Office
                            </mat-option>
                            <mat-option value="Home">
                                Home
                            </mat-option>
                            <mat-option value="Shopping Area">
                                Shopping Area
                            </mat-option>
                            <mat-option value="Mixed">
                                Mixed
                            </mat-option>
                            <mat-option value="Apartment">
                                Apartment
                            </mat-option>
                            <mat-option value="Isolated">
                                Isolated
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="formControlError(form, 'locale') === 'required'">Local is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="field">
                <h4>Square footage of location</h4>
                <mat-form-field appearance="outline" appFormFieldFilled>
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="trigger-area" (click)="squareFootageAutocomplete.isOpen ? squareFootageTrigger.closePanel() : squareFootageTrigger.openPanel()"></div>
                        <input matInput #squareFootageInput
                           [matAutocomplete]="squareFootageAutocomplete"
                           #squareFootageTrigger="matAutocompleteTrigger"
                           [anchorAutocompleteOnScroll]="squareFootageTrigger"
                           formControlName="squareFootage"
                           autocomplete="off"
                           name="avoidSearch"
                           (focus)="squareFootageInput.blur()"
                           enterkeyhint="next"
                        />
                        <mat-icon matSuffix class="rotate" [class.do]="squareFootageAutocomplete.isOpen">expand_more</mat-icon>
                    </div>
                    <mat-autocomplete #squareFootageAutocomplete="matAutocomplete" (optionSelected)="sqFootageSelected($event.option.value)"
                                      (opened)="activeExplanationChange('squareFootage', true)"
                                      (closed)="activeExplanationChange('squareFootage', false)"
                    >
                        <mat-option [value]="value" *ngFor="let value of sqFootageKeys">
                            {{ sqFootageDisplayValues[value] }}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="formControlError(form, 'squareFootage') === 'required'">Square footage is required</mat-error>
                </mat-form-field>
            </div>
            <div class="field">
                <h4>Refund Policy</h4>
                <div class="form-checkbox">
                    <mat-checkbox formControlName="hasRefundPolicy" color="primary"></mat-checkbox>
                    <p>I have a refund policy</p>
                </div>
                <ng-container *ngIf="showOptionalField('hasRefundPolicy', true)">
                    <mat-form-field appearance="outline" appFormFieldFilled>
                        <input matInput
                               formControlName="refundPolicy"
                               placeholder="Describe your refund policy"
                               autocomplete="off"
                               name="avoidSearch"
                               (focus)="activeExplanationChange('refundPolicy', true)"
                               (focusout)="activeExplanationChange('refundPolicy', false)"
                               enterkeyhint="next"
                        />
                        <mat-error *ngIf="formControlError(form, 'refundPolicy') === 'required'">Refund policy is required</mat-error>
                    </mat-form-field>
                </ng-container>
            </div>
        </form>
        <div class="actions">
            <button mat-flat-button color="primary" (click)="nextClick.emit()">{{ (progress === 100) ? 'Finalize' : 'Next' }}</button>
        </div>
    </div>

    <div class="divider"></div>

    <div>
        <div class="info" #containerDiv>
            <div class="background" #backgroundDiv [ngStyle]="bgStyles"></div>

            <div class="field-explanation" #itemDiv [class.active]="activeIndex === i" *ngFor="let field of fieldExplanations; let i = index" [id]="'nuvei_app_' + field.id">
                <p>{{ field.title }}</p>
                <h4>{{ field.explanation }}</h4>
            </div>
        </div>
    </div>
</div>